"use client";

import {
	DialogClose,
	DialogContent,
	DialogRoot,
	DialogTrigger,
	DialogViewport,
	classed,
	clsx,
} from "@frend-digital/ui";

import { Close24 } from "@/components/icons/Close24";
import { SolarMinimizeSquare3Linear } from "@/components/icons/Solar";
import { IconButton } from "../IconButton";
import styles from "./Drawer.module.css";
import type { ComponentProps } from "react";

export const DrawerRoot = DialogRoot;
export const DrawerViewport = classed(DialogViewport, styles.viewportBase, styles.viewport, {
	variants: {
		side: {
			right: styles.right,
		},
	},
});
export const DrawerContent = classed(DialogContent, styles.content);
export const DrawerMain = classed("div", styles.main);

const StyledDialogClose = classed(DialogClose, styles.close, {
	variants: {
		static: {
			true: styles.static,
		},
	},
});

export const DrawerClose = ({
	className,
	children,
  static: isStatic,
	...rest
}: ComponentProps<typeof DialogClose> & { static?: boolean }) => {
	return (
		<DialogClose className={clsx(styles.close, className, isStatic && styles.static)} asChild {...rest}>
			<IconButton>{children || <Close24 />}</IconButton>
		</DialogClose>
	);
};
export const DrawerTrigger = DialogTrigger;

export const DrawerHeader = classed("header", styles.header);
export const DrawerFooter = classed("footer", styles.footer);

export const ModalRoot = DialogRoot;
export const ModalViewport = classed(DialogViewport, styles.viewportBase, styles.modalViewport, {
	variants: {
		side: {
			right: styles.right,
			left: styles.left,
		},

		animated: {
			true: styles.animated,
			false: styles.notAnimated,
		},
	},

	defaultVariants: {
		animated: true,
	},
});
export const ModalContent = classed(DialogContent, styles.content);
export const ModalMain = classed("div", styles.main);
export const ModalHeader = classed("header", styles.header);
export const ModalFooter = classed("footer", styles.footer);

export const ModalTrigger = DialogTrigger;

export const ModalClose = () => {
	return (
		<DialogClose className={styles.close} asChild>
			<IconButton>
				<SolarMinimizeSquare3Linear />
			</IconButton>
		</DialogClose>
	);
};

export const DialogTitle = classed("h2", styles.title);

export { DialogTitle as DrawerTitle, DialogTitle as ModalTitle };
